// extracted by mini-css-extract-plugin
export default {"wrapper":"Sorter_wrapper__w6xh7","carper":"Sorter_carper__uqz+U","down":"Sorter_down__vzgft","asc":"Sorter_asc__R8GOl","desc":"Sorter_desc__cveUb"};